import * as React from "react";
import { Icon } from "./styles";
import { colors } from "styles/styles";

const IconCalendar = () => (
  <React.Fragment>
    <div className={Icon}>
      <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g transform={`scale(${0.11}) translate(-219, -129)`}>
          <path
            id="svg_2"
            d="m267.027933,201.428287c1.6898,-1.44515 2.209738,-2.370046 2.209738,-2.370046l0.129985,0c0,0 -0.064992,1.271732 -0.064992,2.543464l0,26.345086l-10.133383,0l0,4.966499l26.376043,0l0,-4.966499l-10.003399,0l0,-35.820453l-5.713907,0l-10.978283,9.475367l3.894122,3.583972l4.284076,-3.75739zm23.857591,28.368296c0,0.987519 0.129985,2.02321 0.324962,3.116707l29.55525,0l0,-4.966499l-22.731058,0c0.124569,-9.301949 22.016143,-11.378148 22.016143,-24.789141c0,-7.047515 -6.033452,-11.734619 -14.482451,-11.734619c-10.32836,0 -14.487867,7.741187 -14.487867,7.741187l4.739022,2.827677c0,0 3.249615,-5.20254 9.293899,-5.20254c4.804014,0 8.24319,2.712065 8.24319,6.758485c0,9.615065 -22.471089,11.696081 -22.471089,26.248743zm-22.546913,-84.79659l-10.83205,0l0,16.065252l10.83205,0l0,-16.065252zm59.576277,5.616817l0,15.270419l-21.664101,0l0,-15.270419l-32.496151,0l0,15.260785l-21.653269,0l0,-15.260785l-13.101365,0l0,104.38319l102.000003,0l0,-104.38319l-13.085117,0zm7.674508,99.561206l-91.167953,0l0,-71.852862l91.167953,0l0,71.852862zm-13.090533,-105.178023l-10.83205,0l0,16.065252l10.83205,0l0,-16.065252z"
            strokeWidth="1.5"
            stroke={colors.hooplaBlue}
            fill={colors.hooplaBlue}
          />
          <rect
            stroke={colors.hooplaBlue}
            id="svg_3"
            height="80"
            width="94.999998"
            y="170"
            x="242.500002"
            strokeWidth="1.5"
            fill={colors.hooplaBlue}
          />
          <rect
            stroke={colors.hooplaBlue}
            id="svg_5"
            height="17"
            width="78"
            y="189.78125"
            x="251"
            strokeWidth="1.5"
            fill="#ffffff"
          />
          <rect
            stroke={colors.hooplaBlue}
            id="svg_6"
            height="17"
            width="78"
            y="219.78125"
            x="251"
            strokeWidth="1.5"
            fill="#ffffff"
          />
        </g>
      </svg>
    </div>
  </React.Fragment>
);

export default IconCalendar;
